import SpriteSymbol from "../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.store/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cfo",
  "use": "icon-cfo-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-cfo\"><path d=\"M512 64C264.8 64 64 264.8 64 512s200.8 448 448 448 448-200.8 448-448S759.2 64 512 64z m36 384H704v64H544.8v64H704v64H544.8v193.6h-64V640H320v-64h160.8v-64H320v-64h157.6L332 302.4l45.6-45.6 136 136 136-136 45.6 45.6L548 448z\" p-id=\"5073\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol